// extracted by mini-css-extract-plugin
module.exports = {"row--first":"_0a3a94f455--row--first--FvJgp","row--second":"_0a3a94f455--row--second--jU7Kl"};